<template>
	<div>
		<h4>Content van over ons pagina</h4>
		<quill-editor v-model="content" class="mt-2"></quill-editor> <!--:options="{theme: 'bubble'}" -->
		<vs-button :disabled="loading" @click="saveAboutUs()" color="success" class="mt-2">Opslaan</vs-button>
	</div>
</template>
<script>
	import api from '../../api';
	export default {
		name: 'AboutUs',
		components: {},
		props: {},
		data () {
			return {
				content: "",
				loading: false
			}
		},
		computed: {

		},
		mounted () {
			this.getAboutUs();
		},
		methods: {
			getAboutUs(){
				this.loading = true;
				api.post("admin/settings", {keys: ['about-us']}).then(response=>{
					this.content = response.data[0].value;
					this.loading = false;
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				})
			},
			saveAboutUs(){
				this.loading = true;
				api.put("admin/settings", {settings: {'about-us': this.content}}).then(()=>{
					this.$vs.dialog({
						title: 'Gelukt!',
						text: 'Opslaan van de over ons pagina is gelukt',
						color: 'success'
					});
					this.loading = false;
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				})
			}
		}
	}

</script>
